<form [formGroup]="formGroup">
  <p
    *ngIf="isShowLabelOutside"
    class="tui-space_bottom-2"
  >
    <b>
      {{ label }}
      <span *ngIf="validators.required">*</span>
    </b>
  </p>
  <tui-text-area
    [formControlName]="formControlName"
    [tuiTextfieldSize]="size"
    [nativeId]="id"
    [pseudoInvalid]="invalid === undefined ? null : invalid"
    [pseudoFocus]="focus ?? null"
    [expandable]="properties?.expandable ?? true"
    [readOnly]="properties?.readOnly ?? false"
    (focusedChange)="handleFocusedChange($event)"
    [tuiTextfieldLabelOutside]="isShowLabelOutside"
  >
    <div *ngIf="!isShowLabelOutside">
      {{ label }}
      <span
        class="tui-required"
        *ngIf="validators.required"
      ></span>
    </div>
    <div *ngIf="isShowLabelOutside">
      {{ placeholder }}
    </div>
    <textarea
      tuiTextfield
      [attr.placeholder]="placeholder ?? ''"
      [attr.required]="validators.required"
    ></textarea>
  </tui-text-area>
</form>
